/* src/app/workshop/components/settings/severities/severities.component.scss */
/*# sourceMappingURL=severities.component.css.map */
